<template>
  <div class="font-roboto">
    <TrainingHeader :title="layoutTitle" />

    <div
      class="px-5 text-sm lg:text-sectionHdr py-10"    >
      <div class="container mx-auto" >
        <slot></slot>
      </div>

    </div>
    <TrainingFooter />
  </div>
</template>

<script setup lang="ts">

withDefaults(
  defineProps<{
    layoutTitle?: string;
  }>(),
  {
    layoutTitle: "Safetynet",
  }
);


</script>
